import { useEffect, useMemo, useState } from "react";

import { Grid } from "@mui/material";

import InputControlled from "components/Controllers/Input";
import AutocompleteControlled from "components/Controllers/Autocomplete";

import { documentTypes, accountTypes } from "pages/PaymentLink/options";

import { getBanks } from "services/payments";

const PSEForm = (props) => {
  const { control, documents, samePersonPay } = props;

  const [banks, setBanks] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getBanks();
        if (response.data.status === "success") {
          setBanks(response.data.data.items);
        }
      } catch (error) {
        console.error("Fetch error: ", error);
      }
    };

    fetchData();
  }, []);

  return (
    <Grid container spacing={2} pr={{ md: 8 }} pb={{ md: 1 }}>
      <Grid item xs={12} md={6}>
        <AutocompleteControlled
          label="Banco"
          name="bank"
          control={control}
          rules={{ required: false }}
          options={banks}
          disabled={!banks.length}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <AutocompleteControlled
          label="Tipo de cuenta"
          name="account_type"
          control={control}
          rules={{ required: true }}
          options={accountTypes}
        />
      </Grid>
      <Grid item xs={12}>
        <InputControlled
          label="Número de cuenta"
          name="account_number"
          control={control}
          rules={{ required: true }}
          inputProps={{ maxLength: 16 }}
        />
      </Grid>
      {!samePersonPay && (
        <>
          <Grid item xs={12} md={6}>
            <AutocompleteControlled
              label="Tipo de Documento"
              name="possible_customer_document_type"
              control={control}
              rules={{ required: !samePersonPay }}
              options={documents}
              disabled={samePersonPay}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputControlled
              label="N° Documento"
              name="possible_customer_document_number"
              control={control}
              rules={{ required: !samePersonPay }}
              inputProps={{ maxLength: 15 }}
              disabled={samePersonPay}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputControlled
              label="Nombres"
              name="possible_customer_firstname"
              control={control}
              rules={{ required: !samePersonPay }}
              inputProps={{ maxLength: 30 }}
              disabled={samePersonPay}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <InputControlled
              label="Apellidos"
              name="possible_customer_lastname"
              control={control}
              rules={{ required: !samePersonPay }}
              inputProps={{ maxLength: 30 }}
              disabled={samePersonPay}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default PSEForm;
